import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Header.css";
import icon from "../images/icon.png";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoSize, setLogoSize] = useState("170px");

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setLogoSize("120px");
      } else {
        setLogoSize("170px");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigate = useNavigate();

  const handleScrollTo = (id) => {
    setIsMenuOpen(false);
    navigate("/");
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo-link">
          <img
            src={icon}
            alt="Logo"
            className="logo-icon"
            style={{ width: logoSize, height: "auto" }}
          />
        </Link>
        <button className="menu-icon" onClick={toggleMenu}>
          &#9776;
        </button>
      </div>
      <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-list">
          <li className="nav-item">
            <span onClick={() => handleScrollTo("service-intro")}>
              Linectとは
            </span>
          </li>
          <li className="nav-item">
            <span onClick={() => handleScrollTo("features-section")}>
              基本機能
            </span>
          </li>
          <li className="nav-item">
            <span onClick={() => handleScrollTo("slider-section")}>
              導入事例
            </span>
          </li>
          <li className="nav-item">
            <span onClick={() => handleScrollTo("pricing-section")}>料金</span>
          </li>
          <li className="nav-item">
            <span onClick={() => handleScrollTo("process-flow")}>
              運用開始までの流れ
            </span>
          </li>
          <li className="nav-item button-item1">
            <Link to="/download" onClick={toggleMenu}>
              資料請求
            </Link>
          </li>
          <li className="nav-item button-item2">
            <Link to="/inquiry" onClick={toggleMenu}>
              お問い合わせ
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
